/**
 * CollectionControl — Dropdown populated from Storefront Collection master data.
 * Shows collection titles as labels, saves slugs as values.
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Label } from '@/components/ui/label'
import {
  useCollections,
  useStorefrontTenantKey,
} from '@/features/storefront/collections/hooks'

interface CollectionControlProps {
  value: string
  onChange: (v: string) => void
  label: string
}

export function CollectionControl({ value, onChange, label }: CollectionControlProps) {
  const { tenantKey } = useStorefrontTenantKey()
  const { data: collections, isLoading } = useCollections(tenantKey)

  return (
    <div className="space-y-1.5">
      <Label className="text-[13px] font-medium text-gray-600">{label}</Label>
      <Select value={value || ''} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue placeholder={isLoading ? 'Loading...' : 'Select collection'} />
        </SelectTrigger>
        <SelectContent>
          {(collections ?? []).map((col) => (
            <SelectItem key={col.slug} value={col.slug}>
              {col.title} ({col.product_count})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
